import type { RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useGridStore } from '@/stores/grid';
import { useSheetsStore } from '@/stores/sheets';
import { useDictionariesStore } from '@/stores/dictionaries';
import { useObservation } from '@/composables/useObservation';
import { workbookTabKey } from './workbookRoute';

/** Чтение начинается вместе с загрузкой компонента, а не после его создания. */
export function preloadWorkbookRoute(route: Pick<RouteLocationNormalized, 'name' | 'params' | 'query'>): void {
  if (!useAuthStore().isAuthenticated || useObservation().active.value) return;
  const key = workbookTabKey(route);
  if (key === 'grid') {
    const grid = useGridStore();
    // Отбор из ссылки применяет GridView: не читаем перед ним общую выборку.
    if (grid.initialised || grid.loading || route.query.filters) return;
    void grid.enter();
    void useDictionariesStore().loadAll().catch(() => {});
  } else if (key && useAuthStore().can('sheet.view')) {
    const code = String(route.params.code);
    const sheet = useSheetsStore(code);
    if (!sheet.detail && !sheet.loading) void sheet.enter(code);
  }
}
